import React from "react"

import * as style from "./Grid.module.scss"

const Grid = ({ children, compact, columns }) => {
  if (compact === "") compact = true

  return (
    <div className={style.grid} data-columns={columns} data-compact={compact}>
      {children}
    </div>
  )
}

export default Grid
